module.exports = __webpack_public_path__ + "img/circle.6ab113a3.png";